import fuze from './fuze'
import invariant from './invariant'

export function Nil(obj) {
  return obj === Nil
}

fuze(Nil, {
  value(obj) {
    return Nil(obj) ? null : obj
  },

  isNil: Nil,

  assertNil(obj) {
    return this.assert(obj, true)
  },

  assertNotNil(obj) {
    return this.assert(obj, false)
  },

  assert(obj, truth = false) {
    invariant(
      Nil(obj) === truth,
      'Nil assertion failed: expected %s %s to be nil',
      obj,
      truth ? 'not' : '',
    )
    return obj
  },
})

export default Nil
